import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { inject, observer } from 'mobx-react'

import { TabsToggle } from 'components'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import AudienceFilterContent from './components/AudienceFilterContent'
import SavedAudiences from './components/SavedAudiences'
import { GET_WORKSPACE_SAVED_FILTERS } from './query'
import './index.scss'

const AudienceFilterDropdownContent = ({
  onApply,
  onCancel,
  changeAudienceFilter = () => {},
  onTrack,
  isCountryDisabled = false,
  ignoreStore = false,
  audienceFilters,
}) => {
  const t = useTranslate()

  const tabs = [
    {
      name: t(TOLGEE_GLOBALS.newAudience),
      value: 'new',
    },
    {
      name: t(TOLGEE_GLOBALS.savedAudiences),
      value: 'saved',
    },
  ]

  const { loading, error, data, refetch } = useQuery(GET_WORKSPACE_SAVED_FILTERS, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })

  const [activeTab, setActiveTab] = useState(tabs[0].value)

  const handleTab = tab => {
    setActiveTab(tab)
    refetch()
  }

  const AudienceFilterContentWithMobx = inject('AudienceFiltersStore')(
    observer(({ AudienceFiltersStore }) => {
      const filters = ignoreStore ? audienceFilters : AudienceFiltersStore

      return (
        <AudienceFilterContent
          filters={filters}
          isCountryDisabled={isCountryDisabled}
          onTrack={onTrack}
          changeAudienceFilter={changeAudienceFilter}
          onApply={onApply}
          onCancel={onCancel}
          loading={loading}
          error={error}
          data={data}
        />
      )
    })
  )

  return (
    <div className="AudienceFilterDropdownContent">
      <TabsToggle tabs={tabs} onClick={handleTab} activeTab={activeTab} />
      <div className="inner-content">
        {activeTab === 'new' ? (
          <AudienceFilterContentWithMobx />
        ) : (
          <SavedAudiences
            onTrack={onTrack}
            changeAudienceFilter={changeAudienceFilter}
            onApply={onApply}
            onCancel={onCancel}
            loading={loading}
            error={error}
            data={data}
          />
        )}
      </div>
    </div>
  )
}

AudienceFilterDropdownContent.propTypes = {}

AudienceFilterDropdownContent.defaultProps = {}

AudienceFilterDropdownContent.displayName = 'AudienceFilterDropdownContent'

export default AudienceFilterDropdownContent
